import React, { useEffect, useState } from "react";

import cx from "classnames";

import styles from "./RecapRegenerating.module.css";

const SLOGANS = [
	"Crunching numbers and egos…",
	"Decoding the meeting mystery…",
	"Sifting through the verbal chaos…",
	"Translating jargon into English…",
	"Summoning the meeting wizards…",
	"Mining for golden insights…",
	"Sorting through the meeting mayhem…",
	"Brewing up some meeting magic…",
	"Fishing for pearls of wisdom…",
	"Unraveling the meeting spaghetti…",
	"Digging for buried insights…",
	"Polishing the meeting gems…",
	"Translating “blah blah” into insights…",
	"Sifting through the chatter…",
	"Cooking up some meeting stew…",
	"Finding clarity in the chaos…",
	"Harvesting insights from the meeting field…",
	"Dusting off the meeting cobwebs…",
	"Turning meeting mush into magic…",
	"Fishing for insights in a sea of words…",
	"Sorting the wheat from the chaff…",
	"Brewing a potion of insights…",
	"Analyzing the verbal buffet…",
	"Sifting through the meeting soup…",
	"Mining for nuggets of wisdom…",
	"Translating meeting-speak to plain talk…",
	"Extracting the good stuff from the chatter…",
	"Sorting through the meeting jungle…",
	"Finding the diamonds in the dialogue…",
	"Sifting through the meeting confetti…",
	"Converting meeting chaos into clarity…",
	"Fishing for insights in the meeting pond…",
	"Sorting through the meeting puzzle…",
	"Analyzing the verbal fireworks…",
	"Digging for insights in the meeting mine…",
	"Translating “meeting-ese” into sense…",
	"Sifting through the meeting fog…",
	"Extracting the essence of the chatter…",
	"Sorting through the meeting circus…",
	"Solving the meeting riddle…",
	"Hacking the meeting mainframe…",
];

export default function RecapRegenerating() {
	const [randomSlogan, setRandomSlogan] = useState(SLOGANS[Math.floor(Math.random() * SLOGANS.length)]);

	useEffect(() => {
		const interval = setInterval(() => {
			setRandomSlogan(SLOGANS[Math.floor(Math.random() * SLOGANS.length)]);
		}, 7000);

		return () => clearInterval(interval);
	}, []);

	return (
		<div className={styles.wrapper}>
			<div className={styles.glowCluster}>
				<span className={cx(styles.glow, styles.shape1)} />
				<span className={cx(styles.glow, styles.shape2)} />
				<span className={cx(styles.glow, styles.shape3)} />
			</div>
			<div className={styles.title}>{randomSlogan}</div>
		</div>
	);
}
